(function (factory) {
  const estimator = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = estimator;
  if (typeof document !== 'undefined') estimator.start();
})(function () {
  'use strict';
const {FABRICS,LENGTHS,LAYERS,DELTAS,SUSPENSIONS}=window.SLDEstimatorData.products["tree_runner"];
const RIDGELINE_SHARED=window.SLDEstimatorData.shared.hammocks.ridgelines;
const CONTROLS=window.SLDEstimatorData.productControls.treeRunner;

  const FIELD_LABELS = Object.freeze({
    'Fabric/Color * (required)': 'Fabric/Color',
    'Length * (required)': 'Length',
    'Layers * (required)': 'Layers',
    'Ridgeline * (required)': 'Ridgeline',
    'Suspension * (required)': 'Suspension',
    'Knee & Shoulder Tie Outs * (required)': 'Knee & Shoulder Tie Outs',
    'Continuous Loops * (required)': 'Continuous Loops',
    'Knotty Mod Locations * (required)': 'Knotty Mod Locations',
    'Peak Shelf * (required)': 'Peak Shelf',
    'Ridgeline Gear Pouch * (required)': 'Ridgeline Gear Pouch',
    'Stuff Sack Options * (required)': 'Stuff Sack Options',
    'Under Quilt Hooks * (required)': 'Under Quilt Hooks',
    'Zippered Shoulder Pouch * (required)': 'Zippered Shoulder Pouch'
  });

  

  

  

  

  

  const clean = (value) => String(value || '').replace(/\s+/g, ' ').trim();
  const own = (object, key) => Object.prototype.hasOwnProperty.call(object, key);

  function deltaFor(field, value) {
    return own(DELTAS, field) && own(DELTAS[field], value) ? DELTAS[field][value] : 0;
  }

  function layerCount(value) {
    return own(LAYERS, value) ? LAYERS[value] : 1;
  }

  function selections(scope) {
    const selected = Object.create(null);
    for (const element of scope.querySelectorAll('select')) {
      const domLabel = clean(element.labels && element.labels[0] && element.labels[0].textContent);
      if (!own(FIELD_LABELS, domLabel)) continue;
      selected[FIELD_LABELS[domLabel]] = clean(element.value);
    }
    return selected;
  }

  function ridgelineWeight(value, length) {
    if (value === 'None (I will use my own)') return 0;
    if (value === 'Yes, Adjustable') return RIDGELINE_SHARED.adjustableByLength[length];
    if (value === 'Yes, Fixed (AmSteel)') return RIDGELINE_SHARED.fixed.baseWeight + (length - RIDGELINE_SHARED.fixed.baseLengthFeet) * RIDGELINE_SHARED.fixed.perFootAdjustment;
    return 0;
  }

  function start() {
    const root = document.querySelector('[data-sld-tree-runner-estimator]');
    if (!root) return;
    const scope = root.closest('product-info') || document;

    function calculate() {
      const choice = selections(scope);
      const fabric = FABRICS[choice['Fabric/Color']];
      const length = LENGTHS[choice.Length];
      const results = root.querySelector('[data-sld-estimator-results]');
      const message = root.querySelector('[data-sld-estimator-message]');

      if (choice['Fabric/Color'] === 'Custom (Please Contact Me First)') {
        if (results) results.hidden = true;
        if (message) message.textContent = 'Custom fabrics require a manual weight estimate. Please contact me before ordering.';
        return;
      }

      if (!fabric || !length) {
        if (results) results.hidden = true;
        if (message) message.textContent = 'Select the hammock length and fabric above to see the estimated weight.';
        return;
      }

      let hammock = ((length * 12 + 8) * fabric.width / 1296) * fabric.density * layerCount(choice.Layers);
      hammock += deltaFor('Continuous Loops', choice['Continuous Loops']);
      hammock += ridgelineWeight(choice.Ridgeline, length);
      hammock += deltaFor('Knotty Mod Locations', choice['Knotty Mod Locations']);
      hammock += deltaFor('Knee & Shoulder Tie Outs', choice['Knee & Shoulder Tie Outs']);
      hammock += deltaFor('Under Quilt Hooks', choice['Under Quilt Hooks']);
      hammock += deltaFor('Peak Shelf', choice['Peak Shelf']);
      hammock += deltaFor('Ridgeline Gear Pouch', choice['Ridgeline Gear Pouch']);
      hammock += deltaFor('Zippered Shoulder Pouch', choice['Zippered Shoulder Pouch']);

      const suspension = SUSPENSIONS[choice['Suspension']] || SUSPENSIONS['None (I will use my own)'];
      const withSuspension = hammock + suspension.weight;
      let mainSack = fabric.width >= 67 ? CONTROLS.mainSacks.wide : CONTROLS.mainSacks.standard;
      if (choice['Stuff Sack Options'] === 'Stuff Sack w/ Zippered Strap Pouch') mainSack += window.SLDEstimatorData.shared.hammockOptions.zipperedStrapSack;
      const packed = withSuspension + mainSack + suspension.sack;

      const set = (selector, value) => {
        const element = root.querySelector(selector);
        if (element) element.textContent = value.toFixed(1) + ' oz';
      };
      set('[data-sld-weight-hammock]', hammock);
      set('[data-sld-weight-suspension]', withSuspension);
      set('[data-sld-weight-packed]', packed);
      if (results) results.hidden = false;
      if (message) message.textContent = '';
    }

    let timer;
    const queue = () => {
      clearTimeout(timer);
      timer = setTimeout(calculate, 75);
    };
    document.addEventListener('change', queue, true);
    document.addEventListener('input', queue, true);
    document.addEventListener('click', queue, true);
    new MutationObserver(queue).observe(scope, {
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'checked', 'selected', 'class', 'aria-checked'],
      childList: true
    });
    calculate();
  }

  return { deltaFor, layerCount, start };
});
